import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ToastService} from "@shared/services/toast.service";

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  private readonly PAGE_SIZE = 5;

  constructor(private http: HttpClient, private toast: ToastService) {
  }

  public getOrders(params: any) {
    let urlParams = '';
    const size = `len=${this.PAGE_SIZE}`;
    Object.keys(params).forEach((key) => {
      urlParams = urlParams + '&' + key + '=' + params[key];
    });
    let url = 'web/orders?' + size + urlParams;
    return this.http.get(url);
  }

  public getOrdersTotal(params: any) {
    let urlParams = '';
    const size = `len=${this.PAGE_SIZE}`;
    Object.keys(params).forEach((key) => {
      urlParams = urlParams + '&' + key + '=' + params[key];
    });
    return this.http.get('web/orders/stats' + '?' + size + urlParams);
  }

  public getOrderDetails(id: any) {
    return this.http.get(`web/orders/${id}/details`)

  }
}
